import React from 'react'
import styles from './SubTabMenu.module.scss'

const SubTabMenu = ({ subSelectedTab, onSubTabChange, counts }) => {
	const SUB_TABS = [
		{ value: 'all', label: '전체', count: counts.allCount },
		{ value: 'wait', label: '계약대기', count: counts.waitCount },
		{ value: 'complete', label: '계약체결', count: counts.completeCount },
		{ value: 'refuse', label: '계약취소', count: counts.refuseCount },
		{ value: 'earlyTermination', label: '중도해지', count: counts.earlyTerminationCount },
	]

	return (
		<div className={styles.subTabMenu}>
			{SUB_TABS.map((tab) => (
				<div
					key={tab.value}
					className={subSelectedTab === tab.value ? styles.active : ''}
					onClick={() => onSubTabChange(tab.value)}>
					{tab.label} {tab.count}
				</div>
			))}
		</div>
	)
}

export default SubTabMenu
